import { render, staticRenderFns } from "./ingredient-row.vue?vue&type=template&id=58404fda&"
import script from "./ingredient-row.vue?vue&type=script&lang=js&"
export * from "./ingredient-row.vue?vue&type=script&lang=js&"
import style0 from "./ingredient-row.vue?vue&type=style&index=0&id=58404fda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports